import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomDialog from '@ui/components/common/Dialog';
import AddEditCollaborator from './AddEditCollaborator';
const AddEditCollaboratorDialog = ({ open, onClose, edit = false, collaborator, onSubmitCollaborator }) => {
    const formRef = useRef(null);
    const { t } = useTranslation();
    const handleSubmit = () => {
        if (formRef.current) {
            formRef.current.submitForm();
        }
    };
    return (_jsx(CustomDialog, { backgroundVariant: 'white', open: open, onClose: onClose, title: edit
            ? t('collaborators.editCollaborator')
            : t('collaborators.addCollaborator'), actions: _jsxs(Box, { width: '100%', display: 'flex', gap: 1, children: [_jsx(Button, { fullWidth: true, onClick: onClose, variant: 'outlined', color: 'inherit', size: 'large', children: t('actions.cancel') }), _jsx(Button, { fullWidth: true, variant: 'contained', color: 'inherit', onClick: handleSubmit, size: 'large', children: edit ? t('actions.editNow') : t('actions.addNow') })] }), children: _jsx(AddEditCollaborator, { ref: formRef, dialog: true, edit: edit, collaborator: collaborator, onSubmit: onSubmitCollaborator }) }));
};
export default AddEditCollaboratorDialog;
